<template>
    <div class="modal-content tw-text-left tw-px-6 tw-relative">
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6 tw-sticky tw-top-0 tw-left-0 tw-w-full tw-pt-6 tw-bg-white">
            <h4 class="tw-font-bold tw-text-lg">{{ $t('privacyPolicy.title') }}</h4>
            <div class="modal-close tw-cursor-pointer tw-z-50" @click="$store.dispatch('closeAllModals')">
                <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567"><g transform="translate(16.821 16.749) rotate(180)"><path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5"/></g></svg>
            </div>
        </div>
        <div class="tw-max-h-3/4 tw-h-64 tw-overflow-y-auto">
            <p>O presente website está alojado num domínio de acesso público cuja propriedade pertence ao WSE e cujos sistemas de informação estão localizados na União Europeia. Os seus direitos à privacidade e à proteção dos seus dados pessoais são importantes para nós. Leia com atenção a informação que se segue.</p>
            <p>Ao utilizar o nosso website, ao solicitar os nossos serviços ou ao pedir que entremos em contacto consigo, poderão ser solicitados ao utilizador alguns dos seus dados pessoais, nomeadamente número de telefone e email. Dependendo da situação (previstas aqui), não será obrigatório que faculte esses dados. Estes dados serão utilizados para processamento dos seus pedidos. Caso o utilizador escolha facultar a referida informação, os seus dados serão arquivados e tratados pelo WSE de acordo com a presente notícia de privacidade e a legislação em vigor.</p>
            <h4>Como nos contactar</h4>
            <p>Contacte-nos se tiver alguma dúvida ou questão sobre esta informação, assim como se pretender exercer os seus direitos.</p>
            <ul>
                <li>&bull; <a href="mailto:privacy@wsenglish.info" class="tw-underline">privacy@wsenglish.info</a></li>
                <li>&bull; 808 20 40 20</li>
                <li>&bull; desloque-se a um dos nossos <a href="https://www.wsenglish.pt/pt/as-escolas/" target="_blank" class="tw-underline">centros</a></li>
            </ul>
            <h4>Responsabilidade</h4>
            <p>O tratamento dos dados é da responsabilidade do Wall Street Institute Portugal – Centro de Inglês, S.A.</p>
            <h4>Os seus direitos</h4>
            <p>Relativamente aos seus dados pessoais, de uma forma global o utilizador tem os seguintes direitos:</p>
            <ul>
                <li>Direito de acesso, retificação, limitação, apagamento, portabilidade;</li>
                <li>Direito a retirar, a qualquer momento, consentimentos que nos deu, o que não invalida as operações de tratamento de dados que foram efetuadas no período em que o consentimento existia;</li>
                <li>Direito de se opor ao tratamento dos dados, inclusivamente para fins de comercialização directa.</li>
            </ul>
            <p>Note que podem existir condições em que, determinados direitos, não podem ser exercidos na sua totalidade, como por exemplo: pedir o apagamento dos seus dados pessoais quando existe um contrato ainda em execução, ou pedir o acesso a dados sem nos dar informação que nos permita identificá-lo inequivocamente.</p>
            <h4>Finalidades, licitude, prazos e destinatários</h4>
            <p>No momento em que recolhemos os seus dados para alguma das seguintes finalidades, e caso se justifique, apresentamos-lhe informação mais concisa e específica sobre a atividade de tratamento de dados em particular. (poderá faltar aqui informação relativa aos servidores na cloud)</p>

            <h4>Pedidos de contacto via formulário:</h4>
            <p>&bull; Pedido de contacto geral</p>
            <p>
                <ul>
                    <li>Ao enviar os seus dados através do formulário com a opção “pedido de contacto geral” está a consentir que o contactemos para responder às questões que nos pretende colocar. Iremos manter os dados para esta finalidade durante 6 meses. Os seus dados podem ser partilhados com algum dos nossos Centros de Inglês, se o tiver escolhido no formulário de contacto, ou se durante o contacto manifestou interesse em visitar um Centro. Se tiver preenchido o campo do “Assunto” teremos essa informação previamente do nosso lado antes de o contactarmos.</li>
                </ul>
            </p><br>
            <p>&bull; Acesso a oferta</p>
            <p>
                <ul>
                    <li>Ao enviar os seus dados através do formulário com a opção “acesso a oferta” está a consentir que o contactemos para confirmar o seu interessa, agendar a sua primeira visita a um dos nossos centros e esclarecer eventuais questões que tenha. Iremos manter os dados para esta finalidade até ao período máximo de 6 meses. Os seus dados poderão ser partilhados com algum dos nossos centros de Inglês, se o tiver escolhido no formulário de contacto, ou se durante o contacto manifestou interesse em visitar um centro.</li>
                </ul>
            </p><br>
            <p>&bull; Saber mais</p>
            <p>
                <ul>
                    <li>Ao enviar os seus dados através do formulário com a opção “saber mais” está a consentir que o contactemos para responder às questões que nos pretende colocar e saber mais sobre o serviço relativamente ao qual pediu para ser contactado. Iremos manter os dados para esta finalidade até ao período máximo de 6 meses. Os seus dados podem ser partilhados com algum dos nossos centros de inglês, se o tiver escolhido no formulário de contacto, ou se durante o contacto manifestou interesse em visitar um Centro.</li>
                </ul>
            </p><br>
            <p>&bull; Recrutamento</p>
            <p>
                <ul>
                    <li>Ao enviar os seus dados através do formulário na área de “recrutamento” está a consentir que o contactemos por email por forma a confirmar a recepção da sua candidatura e que entremos em contacto consigo telefonicamente para marcar uma entrevista presencial num dos nossos centros ou nos nossos escritórios. Iremos manter os seus dados para esta finalidade até ao período máximo de 3 anos. Os seus dados podem ser partilhados com algum dos nossos centros de inglês nomeadamente no que diz respeito à localização da função para a qual o utilizador se tenha candidatado.</li>
                </ul>
            </p><br>
            <p>&bull; Comunicações de Marketing</p>
            <p>
                <ul>
                    <li>Se no preenchimento de algum dos formulários do nosso website selecionou a opção de “Receber comunicações de Marketing” está a consentir que lhe enviemos comunicações, promoções ou outras ofertas por email, SMS ou telefone. Os seus dados não são partilhados com outros destinatários e serão reservados até um período máximo de 6 meses.</li>
                </ul>
            </p>
            <h4>Cookies</h4>
            <p>A qualquer altura, pode desativar a utilização de cookies nas configurações do seu browser. Geralmente, os cookies são somente utilizados na avaliação anónima e estatística e para fins de aperfeiçoamento da orientação do cliente. Ao navegar no nosso website sem alterar as definições de cookies do seu browser, o utilizador expressamente concorda com a utilização de cookies por parte do WSE.</p>
            <h4>Actualização desta notícia de privacidade</h4>
            <p>Queremos advertir os nossos utilizadores que esta notícia de privacidade, pode ser modificada, em caso de necessidade e sem aviso prévio. O WSE indica e disponibiliza publicamente e aqui as datas das passadas actualizações. Se surgirem alterações significativas que possam ter impacto relevante para os titulares, iremos procurar a forma adequada de os informar.</p>
            <p>Versão: <b>WSE.GDPR.V1.052018</b></p><br>

            <h4><b>{{ $t('privacyPolicy.dataProcessor.title') }}</b></h4>
            <p>{{ $t('privacyPolicy.dataProcessor.text', { company:company }) }}</p>
        </div>
        <div class="terms-footer tw-sticky tw-bg-white tw-bottom-0 tw-py-6">
            <button type="button" class="btn-cta terms tw-w-full" @click.prevent="$store.state.privacyPolicy = true; $store.state.modal.terms = false;">
                {{ $t('privacyPolicy.accept') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    data() {
        return {
            company: process.env.VUE_APP_COMPANY,
        };
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

h4 {
    font-weight: 700;
    text-decoration: underline;
    color: $dark-blue;
    padding-top: 20px;
}

p {
    padding-bottom: 8px;
}

ul {

    li {
        padding-left: 12px;
    }
}

</style>
